exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-group[data-v-38f5491d] {\n\tz-index: 1000;\n\tposition: absolute;\n\twidth: 82%;\n\toverflow-y: scroll;\n\theight: 150px;\n\tleft: 30px;\n\tbackground: white;\n}\n.list-group a[data-v-38f5491d]:last-child {\n\tborder-bottom: none;\n}\n.list-group a[data-v-38f5491d] {\n\tborder-left: none;\n\tborder-right: none;\n}\n", ""]);

// exports
